import { render, staticRenderFns } from "./ProjectDependencyItem.vue?vue&type=template&id=c7b4d70c&scoped=true&"
import script from "./ProjectDependencyItem.vue?vue&type=script&lang=js&"
export * from "./ProjectDependencyItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDependencyItem.vue?vue&type=style&index=0&id=c7b4d70c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b4d70c",
  null
  
)

export default component.exports